import {
  getStartupScenePlacing,
  handleInitialPopup,
  saveText
} from './fabricCanvasActionHelpers';
import {
  setFirstSceneOfFirstTheme,
  setLoadingState,
  makeProjectDirtyWithNoUndoSupport,
  toggleDirtyBit,
  updateProjectPlacingsCoords,
  userIdIsPresent,
  isProjectInCart,
  setMessageDialogParams,
  loadCanvas,
  setScenePlacingToProject
} from './fabricCanvasActions';
import {
  shouldSelectFirstSceneOfFirstTheme,
  getDefaultProjectName,
  getOnlyInstagramPlacings,
  getURLQueryStringAsDictionary,
  isSignageSuiteProduct,
  isProjectDirty,
  getCookieActivityNameForWeblink,
  getDefaultProjectNameWithTimeStamp
} from '../utilities/HelperFunctions/HelperFunctions';
import { string } from '../localization';
import { getPlacings, toProjectJSON } from './ProjectData/Project';
import * as api from '../services/api';
import {
  gaOfUsedInspirationTemplates,
  sendCustomDimensionsGAEvents,
  sendLoginGAEvents
} from '../utilities/GAHelpers/GAHelpers';
import { importFromInstagram } from './sideBarActions';
import * as CookieUtils from '../utilities/CookieUtils/CookieUtils';
import * as Constants from '../utilities/constants/Constants';
import { startPollingForPublish } from './blockChainActions';
import {
  setExternalContent,
  setExternalUserId,
  setProjectName
} from './finalCheckActions';
import {
  couponCodeValue,
  orderId
} from '../utilities/HelperFunctions/SignageHelperFunctions';
import { addNewProject, multiWallSupport } from './actions/multiWallHandler';
import { saveProjectAtPath } from '../services/apiHelpers';
import actions from './actionTypes';
import { fetchMultiWallProjects } from './modalActions';

export const initiateProjectSave = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  project.walls.forEach((wall, index) => {
    const startUpScenePlacing = dispatch(getStartupScenePlacing());
    dispatch(setScenePlacingToProject(startUpScenePlacing));
    startUpScenePlacing.wallIndex = index;
  });
  if (dispatch(shouldSelectFirstSceneOfFirstTheme())) {
    dispatch(setFirstSceneOfFirstTheme());
  } else {
    dispatch(setLoadingState(string.LOADING_KEY));
    dispatch(
      initiateProjectAndCall(() => {
        api.sendStartDesignDetail(project.token);
        dispatch(setLoadingState(null));
      })
    );
  }
};

export const initiateProjectAndCall = callback => (dispatch, getState) => {
  dispatch(setProjectDetailsInRequestJSON()).then(() => {
    const { envData } = getState().modal;
    const { project, multiWallProjects } = getState().finalCheck;
    if (
      !getState().modal.envData.wallart_lite_web_link ||
      multiWallProjects.length >= 1
    ) {
      const defaultName = dispatch(getDefaultProjectName(envData.category));
      dispatch(setProjectName(defaultName));
    }
    const projectJSON = toProjectJSON(project);
    api
      .saveProject(projectJSON)

      .then(responseData => {
        dispatch(projectIsInitiated(responseData.data));
        if (
          getState().finalCheck.project.parentId == null &&
          getState().finalCheck.multiWallProjects.length < 2
        ) {
          dispatch(handleInitialPopup());
        }
        if (getState().finalCheck.project.parentId != null) {
          dispatch(gaOfUsedInspirationTemplates());
        }
        callback(responseData);
      })
      .catch(() => {
        dispatch(setLoadingState(null));
      });
  });
};

export const saveProjectAndCall = () => (dispatch, getState) => {
  const promiseObj = new Promise(resolve => {
    const { project } = getState().finalCheck;
    const instagramPlacings = getOnlyInstagramPlacings(getPlacings(project));
    if (instagramPlacings.length > 0) {
      dispatch(importFromInstagram()).then(() => {
        dispatch(continueSaveProject()).then(params => resolve(params));
      });
    } else {
      dispatch(continueSaveProject()).then(params => resolve(params));
    }
  });
  return promiseObj;
};

export const continueSaveProject = () => (dispatch, getState) => {
  const promiseObj = new Promise(resolve => {
    // trigger loading dialog
    dispatch(setLoadingState(string.SAVING_KEY));
    dispatch(
      saveText(() => {
        const { wallCanvas, roomCanvas } = getState().fabricCanvas;
        wallCanvas.discardActiveObject();
        roomCanvas.discardActiveObject();
        dispatch(setProjectDetailsInRequestJSON()).then(() => {
          const { project } = getState().finalCheck;
          if (project.id === null) {
            dispatch(
              initiateProjectAndCall(responseData =>
                dispatch(projectIsSaved(responseData.data, true)).then(params =>
                  resolve(params)
                )
              )
            );
          } else {
            const projectJSOn = toProjectJSON(project);
            api
              .updateProject(projectJSOn, project.token)

              .then(responseData => {
                dispatch(
                  projectIsSaved(responseData.data, false)
                ).then(params => resolve(params));
              })
              .catch(() => {
                dispatch(setLoadingState(null));
              });
          }
        });
      })
    );
  });
  return promiseObj;
};

export const setProjectDetailsInRequestJSON = () => (dispatch, getState) => {
  const { envData, startUpScene } = getState().modal;
  const { wallCanvas } = getState().fabricCanvas;
  const { materialIndex } = getState().sideBar;
  const { project } = getState().finalCheck;

  let projectState;

  project.themeId = startUpScene.themeId;
  project.category = envData.category;
  project.unitSystem = getState().home.unitSystem;
  project.language = getState().home.language;

  if (
    materialIndex != null &&
    getState().modal.storeData.materials.length > materialIndex
  ) {
    project.materialId = getState().modal.storeData.materials[materialIndex].id;
  } else {
    project.materialId = getState().modal.storeData.materials[0].id;
  }

  project.emailAddress = envData.partner_email
    ? envData.partner_email
    : Constants.PLATFORM_EMAIL_ADDRESS;
  project.fullName = envData.partner_name
    ? envData.partner_name
    : Constants.PLATFORM_USER_NAME;

  project.isModified = wallCanvas.getObjects().length > 0;
  project.storeId = envData.store_id;

  const queryDict = getURLQueryStringAsDictionary();

  // Check if these are needed
  if (queryDict.use_inspiration) {
    projectState = Constants.EDITING_STATE;
  } else if (envData.inspiration_designer) {
    projectState = Constants.INSPIRATION_STATE;
  } else if (envData.template_designer) {
    projectState = Constants.TEMPLATE_STATE;
  } else {
    projectState = Constants.EDITING_STATE;
  }
  project.state = projectState;

  if (getState().finalCheck.project.category == Constants.NEW_POSTER_CATEGORY) {
    const selectedSize = getState().home.selectedDefaultSize;
    const displayName =
      selectedSize === Constants.CUSTOM_SIZE
        ? selectedSize.charAt(0).toUpperCase() + selectedSize.slice(1)
        : getState().modal.productSizes.default.sizes[selectedSize].name;

    project.projectSizeName = displayName;
  }
  dispatch(checkForCouponCodeAndOrderId());
  dispatch(setExternalContent());
  dispatch(updateProjectPlacingsCoords());
  dispatch(setProductDetails());
  project.width = getState().home.projectWidth;
  project.height = getState().home.projectHeight;
  return Promise.resolve();
};

export const checkForCouponCodeAndOrderId = () => (dispatch, getState) => {
  const { wallCanvas } = getState().fabricCanvas;
  const isModified = wallCanvas.getObjects().length > 0;
  const orderIdFromURL = orderId();
  const couponCodeFromURL = couponCodeValue();

  if (orderIdFromURL) {
    getState().finalCheck.project.storeOrderId = orderIdFromURL;
  }
  if (couponCodeFromURL && isModified) {
    getState().finalCheck.project.couponCode = couponCodeFromURL;
  }
};

export const setProductDetails = () => (dispatch, getState) => {
  const { selectedProduct } = getState().home;
  const { project } = getState().finalCheck;
  if (selectedProduct) {
    const { templates } = selectedProduct.activeProductSize;

    const templatesDetails = [];
    templates.forEach(template => {
      const dict = {
        id: template.id,
        scale_u: template.scaleU,
        scale_v: template.scaleV,
        offset_u: template.offsetU,
        offset_v: template.offsetV
      };
      templatesDetails.push(dict);
    });
    project.productSizeId = selectedProduct.activeProductSize.id;
    project.templateDetails = templatesDetails;
  }
};

export const projectIsInitiated = responseData => (dispatch, getState) => {
  getState().fabricCanvas.undoInstance.clear();
  dispatch(updateProjectWithResponse(responseData));
  dispatch(sendCustomDimensionsGAEvents());
  dispatch(addNewProject());
};

export const projectIsSaved = (responseData, isInitiatedProject) => (
  dispatch,
  getState
) => {
  getState().fabricCanvas.undoInstance.clear();
  CookieUtils.removeActivityCookie();
  CookieUtils.removeDocumentColorsCookie();
  dispatch(makeProjectDirtyWithNoUndoSupport(false));
  dispatch(toggleDirtyBit());
  dispatch(updateProjectSkeletonIdsWithResponse(responseData));
  // If project has parentId (Inspiration) and it is intital save then poll for inspiration creation
  if (getState().finalCheck.project.parentId && isInitiatedProject) {
    return new Promise(resolve => {
      getResponse(
        api.inspirationCreate,
        responseData.token,
        pollingResponseData => {
          dispatch(
            updateProjectSkeletonIdsWithResponse(pollingResponseData.data)
          );
          dispatch(continueProjectIsSaved(responseData)).then(params =>
            resolve(params)
          );
        }
      );
    });
  }
  return dispatch(continueProjectIsSaved(responseData));
};

export const continueProjectIsSaved = responseData => (dispatch, getState) =>
  new Promise(resolve => {
    // On strtech all multiwall projects will share the same scene. We save only current project. Hence other
    // projects should get updated data from backend. Hence sending project group request and updating our data
    // with backend data.
    if (dispatch(multiWallSupport())) {
      const { project } = getState().finalCheck;
      dispatch(fetchMultiWallProjects(project)).then(() => {
        dispatch(loadCanvas()).then(() => {
          resolve([
            responseData.token,
            getState().modal.sessionData.gsku,
            getState().modal.envData.category
          ]);
        });
      });
    } else {
      dispatch(setLoadingState(null));
      resolve([
        responseData.token,
        getState().modal.sessionData.gsku,
        getState().modal.envData.category
      ]);
    }
    dispatch(startPollingForPublish());
  });

export const updateProjectWithResponse = responseData => (
  dispatch,
  getState
) => {
  const { project } = getState().finalCheck;
  project.id = responseData.id;
  project.token = responseData.token;
  project.projectGroupId = responseData.project_group_id;
  const { placings } = responseData;
  project.scenePlacings.forEach((placing, index) => {
    placing.id = placings[index].id;
    placing.wallId = placings[index].wall_id;
  });
  dispatch(updateWallId(responseData));
};

export const updateWallId = wallsResponse => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const projectWalls = project.walls;
  const { activeWall } = project;
  if (wallsResponse) {
    if (isSignageSuiteProduct()) {
      activeWall.id = wallsResponse.walls[activeWall.index].id;
    } else {
      activeWall.id = wallsResponse.wall.id;
    }
  }
  projectWalls.forEach((wall, index) => {
    if (wallsResponse && isSignageSuiteProduct()) {
      wall.id = wallsResponse.walls[index].id;
    } else {
      wall.id = wallsResponse.wall.id;
    }
  });
};

export const updateProjectSkeletonIdsWithResponse = responseData => (
  dispatch,
  getState
) => {
  const { project } = getState().finalCheck;
  const placingsData = [];
  const userPlacingsData = [];

  // Remove deleted placings from project removedPlacings so that it wont go in request again.
  project.removedPlacings.forEach((removedPlacing, index) => {
    if (removedPlacing.destroy) {
      const isDeletedPlacingPresentInResponse =
        responseData.placings.filter(
          responsePlacing => responsePlacing.id == removedPlacing.id
        ).length > 0;
      if (!isDeletedPlacingPresentInResponse) {
        project.removedPlacings.splice(index, 1);
      }
    }
  });

  project.walls.forEach((wall, wallIndex) => {
    wall.removedPlacings.forEach((removedPlacing, index) => {
      if (removedPlacing.destroy) {
        const isDeletedPlacingPresentInResponse =
          responseData.walls[wallIndex].placings.filter(
            responsePlacing => responsePlacing.id == removedPlacing.id
          ).length > 0;
        if (!isDeletedPlacingPresentInResponse) {
          wall.removedPlacings.splice(index, 1);
        }
      }
    });
  });

  // Separating the user placings and placings of canvas. Because in save response, the order of placings are first placings then user placings.
  project.elementPlacings.forEach(elementPlacing => {
    if (elementPlacing.placeableType === Constants.TEXT_ELEMENT_TYPE) {
      userPlacingsData.push(elementPlacing);
    } else {
      placingsData.push(elementPlacing);
    }
  });

  // response willl have startup scene but canvas doesn't.
  let responseIndex = 0;

  project.scenePlacings.forEach(scenePlacing => {
    updateWithResponsePlacingDeta(
      scenePlacing,
      responseData.placings[responseIndex]
    );
    dispatch(updateUserPhotos(scenePlacing));
    responseIndex++;
  });

  placingsData.forEach(placing => {
    updateWithResponsePlacingDeta(
      placing,
      responseData.placings[responseIndex]
    );
    // Need to update unspash user photos with printable width and height
    dispatch(updateUserPhotos(placing));
    responseIndex++;
  });

  userPlacingsData.forEach(userPlacing => {
    updateWithResponsePlacingDeta(
      userPlacing,
      responseData.placings[responseIndex]
    );
    responseIndex++;
  });

  project.walls.forEach((wall, wallIndex) => {
    wall.placings.forEach((wallPlacing, placingIndex) => {
      updateWithResponsePlacingDeta(
        wallPlacing,
        responseData.walls[wallIndex].placings[placingIndex]
      );
    });
  });
};

const updateWithResponsePlacingDeta = (placing, reponsePlacing) => {
  placing.id = reponsePlacing.id;
  placing.placeableId = reponsePlacing.placeable_id;
  placing.placeable.id = placing.placeableId;
};

export const updateUserPhotos = projectPlacing => (dispatch, getState) => {
  if (projectPlacing.placeableType === Constants.USER_PHOTO_TYPE) {
    const userPhotoData = {};
    userPhotoData.store_id = getState().modal.envData.store_id;
    userPhotoData.user_photo = {
      printable_image_width: projectPlacing.placeable.printableImageWidth,
      printable_image_height: projectPlacing.placeable.printableImageHeight
    };
    api.updateUserPhoto(projectPlacing.placeableId, userPhotoData);
  }
};

const getResponse = async (func, token, callback) => {
  let retries = 50;
  let success = false;
  let data = {};
  async function inspirationCreate() {
    func(token).then(res => {
      if (res.data.result === 'SUCCESS') {
        success = true;
        data = res.data;
        callback(data);
      }
    });
  }
  while (retries-- > 0 && !success) {
    inspirationCreate();
    await new Promise(resolve => setTimeout(resolve, 10000));
  }
  return data;
};

// All save related functions

export const saveOnlyIfDirtyAndCall = () => (dispatch, getState) =>
  new Promise(resolve => {
    const webLink = getState().modal.envData.wallart_lite_web_link;
    const isFirstSave = getState().fabricCanvas.isWebLinkFirstSave;

    if (getState().modal.envData.view_only_preview_mode) {
      resolve([
        null,
        getState().modal.sessionData.gsku,
        getState().modal.envData.category
      ]);
      return null;
    }
    if (webLink) {
      const {
        webLinkSaveIdentifier,
        isSaveViaWallNavigation
      } = getState().fabricCanvas;

      if (
        webLinkSaveIdentifier === Constants.FINAL_CHECK_KEY ||
        isSaveViaWallNavigation
      ) {
        // from final check
        if (isFirstSave) {
          dispatch(showSaveDialogue()).then(params => resolve(params));
        } else {
          //  silent save
          dispatch(actionProjectAndFolderSaveWasClicked()).then(params =>
            resolve(params)
          );
        }
      } else {
        //  header
        dispatch(showSaveDialogue()).then(params => resolve(params));
      }
    } else if (isProjectDirty(getState().fabricCanvas)) {
      dispatch(saveProjectAndCall()).then(params => resolve(params));
    } else {
      resolve([
        null,
        getState().modal.sessionData.gsku,
        getState().modal.envData.category
      ]);
    }
    return null;
  });

export const showSaveDialogue = () => (dispatch, getState) =>
  new Promise(resolve => {
    dispatch(setLoadingState(string.LOADING_KEY));
    const wallArtLiteMode = getState().modal.envData.wallart_lite_mode;
    const { project } = getState().finalCheck;
    const canHideWeblinkSaveDialog = dispatch(shouldHideWeblinkSaveDialog());
    const ContextContentToken = getState().modal.envData.content_context_token;
    if (wallArtLiteMode) {
      dispatch(platformSaveTheProjectAndCall()).then(params => resolve(params));
      return;
    }
    dispatch(
      userIdIsPresent(user => {
        if (!user) {
          const cookieActivity = getCookieActivityNameForWeblink(
            getState().fabricCanvas.webLinkSaveIdentifier
          );
          dispatch(setLoadingState(null));
          dispatch(saveProjectAndCall()).then(params => {
            if (getState().sideBar.documentColors.length > 0) {
              CookieUtils.saveDocumentColorsCookie(
                getState().sideBar.documentColors
              );
            }
            CookieUtils.saveResumeActivityCookie(
              cookieActivity,
              params[0],
              getState().modal.sessionData.gsku,
              getState().modal.envData.category,
              true,
              ContextContentToken
            );
            dispatch(loginUser());
          });
        } else if (canHideWeblinkSaveDialog) {
          dispatch(setProjectFolderPath()).then(() => {
            dispatch(setLoadingState(null));
            dispatch(actionProjectAndFolderSaveWasClicked()).then(params =>
              resolve(params)
            );
          });
        } else if (dispatch(isProjectInCart(project))) {
          dispatch(platformSaveTheProjectAndCall()).then(params =>
            resolve(params)
          );
        } else if (!getState().modal.envData.folder_support) {
          dispatch(setWebLinkSaveFolderType(Constants.NO_FOLDER_TYPE));
          dispatch(setLoadingState(null));
          dispatch(setWebLinkSaveDialogue(true));
        } else {
          dispatch(setWebUserInfo(null));
          dispatch(setProjectFolderPath()).then(() => {
            dispatch(setLoadingState(null));
            dispatch(setWebLinkSaveDialogue(true));
          });
        }
      })
    );
  });

export const setProjectFolderPath = () => (dispatch, getState) =>
  new Promise(resolve => {
    const { project } = getState().finalCheck;
    const oldProjectName = project.name;
    dispatch(
      getRootFolders(rootFolders => {
        if (rootFolders.length === 0) {
          dispatch(setWebLinkSaveFolderType(Constants.NEW_FOLDER_TYPE));
          resolve();
        } else {
          if (project.id !== null) {
            if (!getState().fabricCanvas.selectedFolderForWebLink) {
              const folderIndex = rootFolders.indexOf(
                dispatch(folderPathForProjectWithExternalId(project.externalId))
              );
              const folder = rootFolders[folderIndex];
              if (folder !== undefined && folder !== null) {
                dispatch(setFolderForWebLink(folder));
              } else {
                dispatch(setFolderForWebLink(rootFolders[0]));
              }
            }
          } else {
            dispatch(setFolderForWebLink(rootFolders[0]));
          }
          dispatch(setWebLinkSaveFolderType(Constants.EXISTING_FOLDER_TYPE));
          dispatch(setProjectName(oldProjectName));
          resolve();
        }
      })
    );
  });

export const actionProjectAndFolderSaveWasClicked = () => (
  dispatch,
  getState
) => {
  dispatch(setLoadingState(string.SAVING_KEY));
  let validateFolderResponse = null;
  const canHideWeblinkSaveDialog = dispatch(shouldHideWeblinkSaveDialog());
  let projectName = '';

  if (canHideWeblinkSaveDialog) {
    validateFolderResponse = 'success';
  } else {
    validateFolderResponse = isFolderUniqueAndValid();
  }

  if (validateFolderResponse === 'success') {
    // const wallArtLiteMode = getState().modal.envData.wallart_lite_mode;
    // let fullNameIsValid = false;
    // let emailAddressIsValid = false;
    // if (wallArtLiteMode) {
    //   const { project } = getState().finalCheck;
    //   const name = project.fullName;
    //   const email = project.emailAddress;

    //   emailAddressIsValid = dispatch(isEmailValid(email));
    //   fullNameIsValid = dispatch(isValidName(name, false));

    //   if (fullNameIsValid) {
    //     // set full name to project
    //   } else {
    //     // /error - invalid name
    //   }
    //   if (emailAddressIsValid) {
    //     // set email to project
    //   } else {
    //     // invalid email address
    //   }
    // }

    if (canHideWeblinkSaveDialog) {
      projectName = getState().finalCheck.project.name;
      if (projectName === null || projectName === '') {
        projectName = getDefaultProjectNameWithTimeStamp();
        dispatch(setProjectName(projectName));
      }
    }

    return dispatch(platformSaveTheProjectAndCall());
  }
  return null;
};

export const platformSaveTheProjectAndCall = () => (dispatch, getState) => {
  const promiseObj = new Promise(resolve => {
    const folderName = getState().fabricCanvas.selectedFolderForWebLink;
    const { project } = getState().finalCheck;
    const wallArtLiteMode = getState().modal.envData.wallart_lite_mode;
    const folderSupport = getState().modal.envData.folder_support;
    let folderPath = '';
    const firstSave = getState().fabricCanvas.isWebLinkFirstSave;

    if (dispatch(shouldHideWeblinkSaveDialog())) {
      folderPath = getState().modal.storeData.internalName;
    }
    if (project.externalId === null || !folderSupport || wallArtLiteMode) {
      folderPath = folderName;
    } else {
      folderPath = dispatch(
        folderPathForProjectWithExternalId(project.externalId)
      );
      if (folderPath !== folderName && folderName !== null) {
        folderPath = folderName;
      }
    }
    saveProjectAtPath(project, folderPath, dispatch, getState, resultJSON => {
      if (resultJSON !== null) {
        if (!wallArtLiteMode) {
          dispatch(setExternalId(resultJSON.id));
        }
        dispatch(saveProjectAndCall()).then(() => {
          if (firstSave) {
            dispatch(setWebLinkFirstSave(false));
          }
          dispatch(setLoadingState(null));
          resolve();
        });
      }
    });
  });
  return promiseObj;
};

export const loginUser = () => dispatch => {
  const dict = {
    header: string.PRE_CHECK_SAVE_DIALOG_TITLE,
    description: string.SAVEDIALOG_MESSAGE,
    stringColor: Constants.DEFAULT_STRING_COLOR,
    onclick: () => dispatch(actionLoginIsClicked()),
    onCancel: null,
    buttonTitles: {
      finish: string.LOGIN_KEY,
      cancel: string.CANCEL_TEXT_KEY
    }
  };
  dispatch(setMessageDialogParams(dict));
};

export const setWebLinkSaveFolderType = type => dispatch => {
  dispatch({
    type: actions.SET_WB_LINK_SAVE_FOLDER_TYPE,
    payload: {
      webLinkSaveFolderType: type
    }
  });
};

export const setWebLinkSaveDialogue = e => dispatch => {
  dispatch({
    type: actions.SET_WEB_LINK_SAVE,
    payload: {
      webLinkSaveDialogue: e
    }
  });
};

export const setWebUserInfo = info => dispatch => {
  dispatch({
    type: actions.SET_WEB_USER_INFO,
    payload: {
      webUserInfo: info
    }
  });
};

// webLink root folder data
export const getRootFolders = callback => (dispatch, getState) => {
  if (getState().modal.envData) {
    const folderSupport = getState().modal.envData.folder_support;
    const platformFlow = getState().modal.envData.platform_flow;
    let aFolderPath = '/';
    if (folderSupport && platformFlow) {
      if (!aFolderPath.startsWith('/')) {
        aFolderPath = `/${aFolderPath}`;
      }
      if (!aFolderPath.endsWith('/')) {
        aFolderPath += '/';
      }

      dispatch(
        getProjectsInfo(projects => {
          dispatch(setProjectFolders(projects));
          const uniquePath = [
            ...new Set(
              projects.map(item => item.state !== 'DELETED' && item.path)
            )
          ];
          const folderNames = uniquePath.filter(
            item => item !== (null || 'null')
          );
          dispatch(setRootFolders(folderNames));
          callback(folderNames);
        })
      );
    }
  }
};

export const getProjectsInfo = callback => (dispatch, getState) => {
  let projectInfo = [];
  if (getState().fabricCanvas.allExternalProjects.length) {
    projectInfo = getState().fabricCanvas.allExternalProjects;
    callback(projectInfo);
  } else if (getState().modal.envData) {
    const wallArtLiteMode = getState().modal.envData.wallart_lite_mode;
    if (projectInfo.length === 0) {
      if (!wallArtLiteMode) {
        const { eCommerceServicesUrl } = getState().modal.storeData;
        const storeId = getState().modal.storeData.id;
        api
          .getECommerceServicesUrl(eCommerceServicesUrl, storeId)
          .then(res => {
            projectInfo = res.data;
            callback(projectInfo);
          })
          .catch(() => {
            dispatch(setLoadingState(null));
          });
      } else {
        callback(projectInfo);
      }
    }
  }
};

export const folderPathForProjectWithExternalId = aExternalProjectId => (
  dispatch,
  getState
) => {
  if (!getState().modal.envData.folder_support) return null;

  let folderPath = null;
  const { allExternalProjects } = getState().fabricCanvas;
  for (let i = 0; i < allExternalProjects.length; ++i) {
    if (aExternalProjectId === allExternalProjects[i].id) {
      folderPath = allExternalProjects[i].path;
      break;
    }
  }
  return folderPath;
};

export const setFolderForWebLink = selectedFolder => dispatch => {
  dispatch({
    type: actions.SET_FOLDER_FOR_WEB_LINK,
    payload: {
      selectedFolderForWebLink: selectedFolder
    }
  });
};

export const shouldHideWeblinkSaveDialog = () => (dispatch, getState) => {
  const { project } = getState().finalCheck;
  const wallartLiteWebLink = getState().modal.envData.wallart_lite_web_link;
  const { hideWeblinkSaveDialog } = getState().modal.storeData;
  return wallartLiteWebLink && (hideWeblinkSaveDialog || project.isMultiWall);
};

export const isFolderUniqueAndValid = () => 'success';

export const setExternalId = id => (dispatch, getState) => {
  getState().finalCheck.project.externalId = id;
  dispatch(setExternalUserId());
};

export const setWebLinkFirstSave = isFirstSave => dispatch => {
  dispatch({
    type: actions.SET_WEB_LINK_FIRST_SAVE,
    payload: {
      isWebLinkFirstSave: isFirstSave
    }
  });
};

export const actionLoginIsClicked = () => (dispatch, getState) => {
  const namedArgumentsJSONObject = getURLQueryStringAsDictionary();
  const requestData = JSON.stringify({
    store_id: getState().modal.storeData.id,
    content_context_token: getState().modal.storeData.content_context_token,
    service_query_parameter: namedArgumentsJSONObject
  });
  dispatch(sendLoginGAEvents(Constants.GA_EVENT_ACTIONS.BEFORE_WEBLINK_LOGIN));
  api.postPerformWithData(requestData, '/api/platform_login');
};

export const setProjectFolders = folders => dispatch => {
  dispatch({
    type: actions.SET_ALL_EXTERNAL_PROJECTS,
    payload: {
      allExternalProjects: folders
    }
  });
};

export const setRootFolders = folders => dispatch => {
  dispatch({
    type: actions.SET_ROOT_FOLDERS,
    payload: {
      rootFolders: folders
    }
  });
};
